
import axios from 'axios';


export const  axios_yousign_fictoyousign = async({lead,formule})=>{
    return await axios.post(`/ficbulletin/fictoyousign/`,{lead,formule},{headers:{'Accept':'application/json'}});
} 


export const  axios_yousign_ficbulletintoyousign = async({lead,formule})=>{
    return await axios.post(`/ficbulletin/ficbulletintoyousign/`,{lead,formule},{headers:{'Accept':'application/json'}});
}

export const  axios_yousign_bulletintoyousign = async({lead,formule})=>{
    return await axios.post(`/ficbulletin/bulletintoyousign/`,{lead,formule},{headers:{'Accept':'application/json'}});
}

export const  axios_yousign_bulletinupload= async({lead,formule})=>{
    return await axios.post(`/ficbulletin/bulletinupload/`,{lead,formule},{responseType:'blob'},{headers:{'Accept':'application/json'}});
}


export const  axios_yousign_ficupload= async({lead,formule})=>{
    return await axios.post(`/ficbulletin/ficupload/`,{lead,formule},{responseType:'blob'},{headers:{'Accept':'application/json'}});
}




export const  axios_yousign_ficbulletinupload= async({lead,formule})=>{
    return await axios.post(`/ficbulletin/ficbulletinupload/`,{lead,formule},{responseType:'blob'},{headers:{'Accept':'application/json'}});
}